import { createAction } from 'redux-actions';
import {
  getSectionReviewersRequest,
  getSectionReviewersOCRRequest,
} from 'api/sections-api';
import { fetchSectionHistoryDetailsWithoutLoading } from 'store/actions/section-review-history-actions';
import { fetchStatementSummarySections } from 'store/actions/statement-summary/sections-summary-actions';
import { showSectionDetailsPanelAction } from 'store/actions/panel-controller-actions';
import { fetchSectionHistoryDetails } from 'store/actions/section-review-history-actions';
import { getUpdatedSectionElementsNotesSummaryCount } from '../../utils/heading-data-utils';
import { fetchSectionIdListStatementContentOcr } from 'store/actions/statement-content-actions';

const sectionDetailsLoaded = createAction('SECTION_DETAILS_LOADED'); // duplicate: to avoid circular dependency

export const appendSectionToSectionReviewList = createAction(
  'SET_SECTION_LIST_STORE',
);

export const fetchSectionReviewsLoaded = createAction(
  'FETCH_SECTIONS_REVIEWS_LOADED',
);

export const fetchSectionReviewsLoading = createAction(
  'FETCH_SECTIONS_REVIEWS_LOADING',
);

export const fetchSectionReviewsError = createAction(
  'FETCH_SECTIONS_REVIEWS_ERROR',
);

export const removeSectionReviewFromStore = createAction(
  'REMOVE_SECTION_REVIEW_FROM_STORE',
);

export const mergeSectionReviewToSectionReviewList = createAction(
  'MERGE_SECTION_REVIEW_TO_SECTION_REVIEW_LIST_IN_STORE',
);

export const removeBulkSectionReviewFromStore = createAction(
  'REMOVE_BULK_SECTION_REVIEW_LIST_FROM_STORE',
);

export const fetchSectionReviews =
  (revisionId, statementId) => async (dispatch, getStore) => {
    try {
      const response = await getSectionReviewersRequest({
        revisionId,
        statementId,
      });
      dispatch(fetchSectionReviewsLoaded({ response }));
    } catch (error) {
      dispatch(fetchSectionReviewsError(error));
    }
  };

export const fetchSectionOCRReviews = () => async (dispatch, getStore) => {
  const {
    revision,
    selectedStatement: { isOCR },
  } = getStore().data;
  try {
    const response = await getSectionReviewersOCRRequest(revision.id);
    dispatch(fetchSectionReviewsLoaded({ response, isOCR }));
  } catch (error) {
    dispatch(fetchSectionReviewsError(error));
  }
};

export const fetchSectionReviewsWithLoading =
  () => async (dispatch, getStore) => {
    const { revision } = getStore().data;
    try {
      dispatch(fetchSectionReviewsLoading());
      const response = await getSectionReviewersRequest({
        revisionId: revision.id,
      });
      dispatch(fetchSectionReviewsLoaded({ response }));
    } catch (error) {
      dispatch(fetchSectionReviewsError(error));
    }
  };

export const fetchSectionReviewsOCRWithLoading =
  () => async (dispatch, getStore) => {
    const {
      revision,
      selectedStatement: { isOCR },
    } = getStore().data;
    try {
      dispatch(fetchSectionReviewsLoading());
      const response = await getSectionReviewersOCRRequest(revision.id);
      dispatch(fetchSectionReviewsLoaded({ response, isOCR }));
    } catch (error) {
      dispatch(fetchSectionReviewsError(error));
    }
  };

export const handleSignOffSuccess =
  ({ data, sectionId }) =>
  async (dispatch, getState) => {
    const {
      data: {
        revision,
        selectedStatement: { isOCR },
      },
    } = getState();
    dispatch(appendSectionToSectionReviewList({ review: data, isOCR }));
    await dispatch(fetchStatementSummarySections({ revisionId: revision.id }));
    dispatch(
      fetchSectionHistoryDetailsWithoutLoading({
        revisionId: revision.id,
        sectionId,
        isOCR,
      }),
      dispatch(fetchSectionReviewsWithLoading()),
    );
  };

export const handleSignOffOCRSuccess =
  ({ data, bookmarkId, isOCR }) =>
  async (dispatch, getState) => {
    const {
      data: { revision },
    } = getState();

    dispatch(appendSectionToSectionReviewList({ review: data, isOCR }));
    await dispatch(fetchStatementSummarySections({ revisionId: revision.id }));
    dispatch(
      fetchSectionHistoryDetailsWithoutLoading({
        revisionId: revision.id,
        sectionId: bookmarkId,
        isOCR,
      }),
    );
    dispatch(fetchSectionReviewsOCRWithLoading());
  };

export const handleRemoveSignOffSuccess =
  (sectionId, appUserId) => async (dispatch, getState) => {
    const {
      data: { revision },
    } = getState();
    dispatch(removeSectionReviewFromStore({ sectionId, userId: appUserId }));
    await dispatch(fetchStatementSummarySections({ revisionId: revision.id }));
    dispatch(
      fetchSectionHistoryDetailsWithoutLoading({
        revisionId: revision.id,
        sectionId,
      }),
    );
  };

export const handleRemoveSignOffOCRSuccess =
  (sectionId, appUserId) => async (dispatch, getState) => {
    const {
      data: {
        revision,
        selectedStatement: { isOCR },
      },
    } = getState();
    dispatch(
      removeSectionReviewFromStore({ sectionId, userId: appUserId, isOCR }),
    );
    await dispatch(fetchStatementSummarySections({ revisionId: revision.id }));

    dispatch(
      fetchSectionHistoryDetailsWithoutLoading({
        revisionId: revision.id,
        sectionId,
        isOCR,
      }),
    );
  };

export const updateSelectedSectionPanel =
  ({ sectionId, bookmarkId, isOCR }) =>
  async (dispatch, getState) => {
    const { contentSectionMap } =
      getState().data.statementContent.sectionsCache;
    // const section = contentSectionMap.get(sectionId);
    let section = isOCR
      ? contentSectionMap.get(sectionId).filter(({ id }) => {
          return id === bookmarkId;
        })[0]
      : contentSectionMap.get(sectionId);

    const {
      data: {
        revision,
        selectedProject: {
          project: { id },
        },
      },
    } = getState();
    dispatch(
      fetchSectionHistoryDetails({
        revisionId: revision.id,
        sectionId: isOCR ? bookmarkId : sectionId,
        isOCR,
      }),
    );
    isOCR && dispatch(fetchSectionIdListStatementContentOcr(revision.id, id));
    let updatedSection = await getUpdatedSectionElementsNotesSummaryCount(
      revision,
      section,
    );

    dispatch(sectionDetailsLoaded(updatedSection));
    dispatch(showSectionDetailsPanelAction());
  };
